import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import { Grid, Grow } from '@mui/material';
import CircumIcon from "@klarr-agency/circum-icons-react";
import Button from '@mui/material/Button';
import { PlusCircle, Briefcase } from 'react-feather';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import { Edit3, Trash2, Eye, Plus, GitPullRequest } from 'react-feather';
import { IconButton, Tooltip } from '@mui/material';
import Toastmessage from '../../components/Toast';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { authApi } from "../../api/api";
import { logout } from "../../features/auth/AuthSlice";


export default function MembersList({ apiResponse }) {
    const [rows, setRows] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [open, setOpen] = useState(false);
    const [deleteLocation, setDeleteLocation] = useState('')
    const [originalRows, setOriginalRows] = useState([]);

    const token = useSelector((state) => state.auth.token);
    const userID = useSelector((state) => state.auth.id);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { treeId } = location.state || {};
    const { member } = location.state || {};

    const columns = [
        {
            field: 'name',
            headerName: 'Trust Name',
            flex: 0.5,
            renderCell: (params) => (
                <Link to="#" className="location-link">
                    {params.value}
                </Link>
            )
        },
        {
            field: 'relationship',
            headerName: 'Relationship',
            flex: 0.5,
        },
        {
            field: 'is_asset_mapped',
            headerName: 'Asset assigned',
            flex: 0.5,
            renderCell: (params) => {
              return params.value == 1 ? 'Yes' : 'No';
            },
          },
        // {
        //     field: 'status',
        //     headerName: 'isActive',
        //     flex: 0.5,
        //     renderCell: (params) => {
        //         return (
        //             <div>
        //                 {params.row.status == 1 ? 'Active' : 'Inactive'}
        //             </div>
        //         )

        //     }
        // },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 1,
            renderCell: (params) => (
                <>
                    <Tooltip title="Edit Trust" arrow>
                        <IconButton
                            onClick={() => handleClickEdit(`${params.row.family_id}`, `${params.row.id}`)}
                            sx={{
                                backgroundColor: '#F3F4FC',
                                color: '#6A6A6A',
                                borderRadius: '50%',
                                padding: '8px', // Reduce padding size
                                marginRight: '8px',
                            }}
                            size="small" // Decrease the button size
                        >
                            <Edit3 size={16} /> {/* Smaller Feather icon size */}
                        </IconButton>
                    </Tooltip>

                    {params.row.estate_mapped_count == 1 && (
                        <Tooltip title="Assets" arrow>
                            <IconButton
                                onClick={() => handleAssets(params.row.id, `${params.row.is_asset_mapped}`, ` ${params.row.family_id}`, ` ${params.row.estate_id}`)}
                                sx={{
                                    backgroundColor: '#F3F4FC',
                                    color: '#6A6A6A',
                                    borderRadius: '50%',
                                    padding: '8px', // Reduce padding size
                                    marginRight: '8px'
                                }}
                                size="small" // Decrease the button size
                            >
                                <Briefcase size={16} />
                            </IconButton>
                        </Tooltip>
                    )}

                </>
            ),
        }
    ];


    const fetchRoleDetails = async (treeId,member) => {
        const input_token = 'FAMILY_MEMBER_LIST';
        const apiUrl = 'list_of_family_members';
        const dataInput = {
            family_tree_id: treeId,
            login_user_id: userID,
            family_member_id: member
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);
            if (data && data.success) {
                const filteredMembers = data.fatherMembers.filter(member => member.trust === 1);

                // Assuming you're setting it in a React state
                setRows(filteredMembers);
                setOriginalRows(filteredMembers)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    useEffect(() => {
        if (treeId && member) {
            fetchRoleDetails(treeId,member);
        }
    }, [treeId,member]);

    const handleSearch = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchText(value);

        const filteredRows = originalRows.filter((row) =>
            row.name.toLowerCase().includes(value)
        );

        setRows(filteredRows);
    };


    const handleDelete = async () => {
        const fetchData = async () => {
            const input_token = deleteLocation + 'DELETE';; // Replace with your actual token
            const apiUrl = 'delete_location'; // Replace with the actual API endpoint

            const dataInput = {
                id: deleteLocation,
                login_user_id: userID
            };
            try {
                const data = await authApi(input_token, dataInput, apiUrl, token);
                if (data && data.success) {
                    await Toastmessage(data.message, true);
                    setOpen(false);
                    await fetchRoleDetails(treeId);; // Refresh the list after deletion
                } else if (data && data.message === 'Token has expired') {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else if (data === undefined) {
                    await Toastmessage('No response from server', false);
                } else {
                    await Toastmessage(data?.message || 'An error occurred', false);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                if (error.response && error.response.status === 401) {
                    dispatch(logout());
                    localStorage.removeItem('token');
                    await Toastmessage('Session expired. Redirecting to login...', false);
                    navigate('/login');
                } else {
                    await Toastmessage('Something went wrong', false);
                }
            }

        };

        // Call the function to make the API call
        await fetchData();
    };

    const handleClickOpen = (id) => {
        setOpen(true);
        setDeleteLocation(id)
    };

    const handleAssets = (id, isCheck, familyId, estate) => {
        if (isCheck == 1) {
            navigate('/editassetmember', { state: { member: id, family_id: familyId, estate_id: estate } });
        } else {
            navigate('/assets', { state: { member: id, family_id: familyId, estate_id: estate } });
        }
    };

    const handleClickEdit = (id, member, isCheck) => {
        navigate('/edittrust', { state: { member: member, treeId: id } });
    };
    const handleClose = () => {
        setOpen(false);
    };


    return (
        <Box className="familytree-container">
            <Box
                sx={{
                    backgroundColor: '#fff',
                    padding: '10px 20px',
                    borderRadius: '0px',
                    backgroundColor: 'var(--theme-bg-light)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px',
                    boxShadow: '0px 1.076px 3.229px 0px rgba(24, 29, 37, 0.10)',
                    width: '100%'
                }}
            >
                <Grid container flex={1}>
                    <Grid item xs={6} display="flex" justifyContent="flex-start" alignItems="center">
                        <p className="mb-0 top-head-icon title-color font-m">Trust List</p>
                    </Grid>
                    <Grid item xs={6} display="flex" justifyContent="flex-end" alignItems="center">
                        {/* <Button
                            component={Link}
                            to="/viewfamilytree"
                            variant="contained"
                            sx={{ marginRight: '10px', padding: '15px 30px', borderRadius: "8px", backgroundColor: 'var(--back-button)', color: "var(--back-color)", '&:hover': { backgroundColor: 'var(--primary-color)' } }}
                        >
                            View Family Tree
                        </Button> */}
                        {apiResponse?.data?.actions?.add && (
                            <Button
                                variant="outlined"
                                onClick={() =>
                                    navigate('/createtrust', {
                                        state:{ treeId: treeId,member: member },
                                    })
                                }
                                sx={{
                                    backgroundColor: 'var(--back-button)',
                                    color: "var(--back-color)",
                                    fontWeight: 'bold',
                                    border: 'none',
                                    padding: '10px 20px'
                                }}
                                startIcon={<PlusCircle sx={{ fontSize: 17 }} />}
                                style={{ textTransform: 'none' }}
                            >
                                Create New Trust
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <Box p={3}>
                <Box className="location-header ">
                    <h6>Total Trust {rows.length}</h6>
                    <TextField
                        label="Search Trust name"
                        variant="outlined"
                        value={searchText}
                        onChange={handleSearch}
                        className="search-input"
                    />
                </Box>
                <div sx={{ m: 0, p: 0 }}>
                    <Box sx={{ width: '100%', display: 'flex' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            pageSize={5}
                            autoHeight
                            pagination
                            disableSelectionOnClick
                            rowsPerPageOptions={[]}
                            className="data-grid"
                            sx={{ width: '100%' }} // Ensure DataGrid takes full width
                        />
                    </Box>
                </div>
            </Box>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion?"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this member?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Disagree</Button>
                    <Button onClick={handleDelete} autoFocus>
                        Agree
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>

    )
}